import { useEffect, useState } from "react";
import request from "../../../Helpers/API";
export const MostrarSelect = ({
  name,
  value,
  onChange,
  onPrimerMostrar
}) => {
  const [state, setState] = useState([]);

  useEffect(() => {
    request
      .get("MensajeriaGeneral/GetAccesosMensajeria")
      .then((result) => {
        const accesoOptions = result.map((acceso) => ({
          value: acceso.id,
          label: acceso.menu,
        }));
        setState(accesoOptions);
        if (accesoOptions.length > 0 && onPrimerMostrar) {
          onPrimerMostrar(accesoOptions[0].value);
        }
      })
      .catch((error) => {
        console.error("Error obteniendo lineas:", error);
      });
  }, []);
  return (
    <select
      className="select-mostrar"
      name={name}
      value={value}
      onChange={onChange}
    >
      {state.map((item) => (
        <option key={`menu-${item.value}`} value={item.value}>
          {item.label}
        </option>
      ))}
    </select>
  );
};
